import { useDevMode } from '../state'
import { HttpAgent, HttpAgentOptions } from '@dfinity/agent'
import { DEFAULT_LOCALHOST, IC_HOST } from '../constants/urls'
import { logger } from '../logger'

const getAgent = (options?: HttpAgentOptions) => {
  const { devEnabled, activeNetwork, networks } = useDevMode.getState()

  const network = activeNetwork ? networks[activeNetwork] : networks[Object.keys(networks)[0]]

  const host = options?.host || devEnabled ? network?.hostUrl || DEFAULT_LOCALHOST : IC_HOST

  let boundFetch
  if (window.isPolyfill || !window.fetch) {
    boundFetch = fetch.bind(globalThis)
  } else {
    boundFetch = window.fetch.bind(window)
  }

  const agent = HttpAgent.createSync({
    ...options,
    host,
    fetch: boundFetch,
  })

  if (devEnabled) {
    agent.fetchRootKey().catch(logger.debug)
  }

  return agent
}

export default getAgent
